var map = {
	"./Home": [
		6612,
		9,
		612
	],
	"./Home/": [
		6612,
		9,
		612
	],
	"./Home/index": [
		6612,
		9,
		612
	],
	"./Home/index.tsx": [
		6612,
		9,
		612
	],
	"./Privacy": [
		2421,
		9,
		421
	],
	"./Privacy/": [
		2421,
		9,
		421
	],
	"./Privacy/index": [
		2421,
		9,
		421
	],
	"./Privacy/index.jsx": [
		2421,
		9,
		421
	],
	"./Privacy/pdf/privacy.pdf": [
		93,
		1,
		93
	],
	"./Wsafty": [
		4041,
		9,
		41
	],
	"./Wsafty/": [
		4041,
		9,
		41
	],
	"./Wsafty/index": [
		4041,
		9,
		41
	],
	"./Wsafty/index.tsx": [
		4041,
		9,
		41
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 717;
module.exports = webpackAsyncContext;